export default __webpack_public_path__ + "static/media/calibri-italic.f5a246bc.ttf";